import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ApiService } from '../../../services/api.service';
import { AuthStateService } from '../../../services/auth-state.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  public loading = false;
  public visible = false;
  public error = false;
  public content: string = null;
  public accepted = false;
  public submitting = false;

  constructor(
    private auth: AuthStateService,
    private api: ApiService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    // this.showPrivacy();
  }

  public showPrivacy(): void {
    if (this.auth.hasPrivacy() !== true) {
      this.visible = true;
      this.loading = true;
      this.api.loadPrivacy().subscribe({
        next: (result: any) => {
          const lang = this.transloco.getActiveLang().toUpperCase();
          if (result.data[lang]) {
            this.content = result.data[lang];
          }
        },
        error: (error: any) => {
          this.error = true;
        }
      }).add(() => {
        this.loading = false;
      });
    }
  }

  public save(): void {
    this.submitting = true;
    this.api.savePrivacy().subscribe({
      next: (result: any) => {
        this.auth.refreshToken(result.data.access_token);
      },
      error: (error: any) => {}
    }).add(() => {
      this.submitting = false;
      this.accepted = false;
      this.visible = false;
    });
  }

  public hide(): void {
    this.auth.logout();
  }

}
